import { getSupabaseClient } from '../lib/supabase';

const KEY = "gc_admin_token";

export type User = { email: string; role: "admin" | "guide" | "seeker" };

function getEnv(): any {
    return (window as any).__ENV__;
}

function getSB() {
    return getSupabaseClient();
}

export function getUser(): User | null {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as User) : null;
}

export async function signIn(email: string, password: string): Promise<User> {
    const sb = getSB();
    const { data, error } = await sb.auth.signInWithPassword({ email, password });
    if (error) throw new Error(error.message || "Login failed");
    const userId = data.user?.id;
    if (!userId) throw new Error("No user returned");

    // Check admin role via RLS-readable view/table
    const { data: adminRows, error: adminErr } = await sb
        .from("admins")
        .select("user_id")
        .eq("user_id", userId)
        .limit(1);
    if (adminErr) throw new Error(adminErr.message);
    const isAdmin = (adminRows?.length ?? 0) > 0;
    if (!isAdmin) {
        await sb.auth.signOut();
        throw new Error("This account is not an admin");
    }

    const user: User = { email, role: "admin" };
    localStorage.setItem(KEY, JSON.stringify(user));
    return user;
}

export async function signOut(redirect = true) {
    localStorage.removeItem(KEY);
    try {
        const sb = getSB();
        await sb.auth.signOut();
    } catch (err) {
        // Ignore errors during sign out (e.g., if already signed out)
        console.error("Error during sign out:", err);
    }
    if (redirect) {
        window.location.href = "/login";
    }
}

export function isAuthed(): boolean {
    return getUser()?.role === 'admin';
}
